import { createContext } from "react";

const ContactFormGeneralContext = createContext();

export default ContactFormGeneralContext;